export function getStyles(obj: object) {
  const styleArray: Array<string> = []
  Object.keys(obj).forEach((key) => {
    styleArray.push(`${key}:${obj[key]}`)
  })

  return styleArray.join(';').concat(';')
}
